const QCNotesCreatorsCategories = ['VOA', 'SE']

export { QCNotesCreatorsCategories }
